export default __webpack_public_path__ + "static/social3-4277f7c2a086dd6fea3800baf1a3c9d3.png";